import { Component } from '@angular/core';
import { enterUnfold } from '@tekman/shared/utils';

@Component({
  selector: 'tekman-dropdown-menu',
  templateUrl: './dropdown.component.html',
  animations: [enterUnfold],
})
export class DropdownComponent {}
